module.exports = __webpack_public_path__ + "media/images/ic_fav-1ece1e236a0927725e8fa2d63da70595.ico";